import st from './Translate.module.scss'
import React, { useEffect, useState } from 'react'
import { HeaderButton } from 'components/UI/SuperButton/SuperButton'
import style from 'components/Modules/Groups/GroupList/GroupsList.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import styles from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import useLocalization from 'hooks/useLocalization'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import { observer } from 'mobx-react'
import CreateTranslation from './ModalForTranslate/CreateTranslation'
import ChangeTranslation from './ModalForTranslate/ChangeTranslation'
import Pagination from 'components/UI/Pagination/Pagination'
import listingStore from 'Stores/listingStore'
import { superAxiosRequest } from 'axiosApi'
import CreatePartition from './ModalForTranslate/CreatePartition'

const Translate = () => {
  const {
    page,
    perPage,
    setPage,
    setPerPage,
    setFilterParams,
    filterType,
    setFilterType,
  } = listingStore

  const [data, setData] = useState([])
  const [partitions, setPartitions] = useState([])
  const [subPartitions, setSubPartitions] = useState([])
  const [languages, setLanguages] = useState([])
  const [languagesDictionary, setLanguagesDictionary] = useState({})
  const [activeElement, setActiveElement] = useState(null)
  const [activeElementState, setActiveElementState] = useState(null)
  const [searchText, setSearchText] = useState('')

  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [filter, updateFilter] = useLocalStorageFilter()

  const [englishText, setEnglishText] = useState('')
  const [russianText, setRussianText] = useState('')
  const [kazakhText, setKazakhText] = useState('')
  const [activeTab, setActiveTab] = useState('kazakh')

  const handleTabClick = (tab) => {
    setActiveTab(tab)
  }

  const handleSearchClear = () => {
    setSearchText('')
    const { search, ...obj } = filter
    updateFilter(obj)
    setTextValues(filterTextValues.filter((field) => field.key !== 'search'))
  }

  const onBeforeCreateTranslation = (formData) => {
    let parsedTranslation
    try {
      parsedTranslation = JSON.parse(formData?.translation)
    } catch (err) {
      alert('Please fix JSON in your field')
    }
    return {
      partition: formData?.partition?.id,
      subpartition: formData?.subPartition?.id,
      language: formData?.language?.id,
      text: parsedTranslation,
    }
  }

  const onBeforeUpdateTranslation = (formData) => {
    let parsedTranslation
    try {
      parsedTranslation = JSON.parse(formData?.translation)
    } catch (err) {
      alert('Please fix JSON in your field')
    }
    return {
      body: {
        partition: formData?.partition?.id,
        subpartition: formData?.subPartition?.id,
        language: formData?.language?.id,
        text: parsedTranslation,
      },
      link: `localization/translate/${formData?.id}`,
    }
  }

  useEffect(() => {
    const translationsApiConf = {
      method: 'get',
      link: 'localization/translations',
      params: {
        limit: perPage,
        offset: (page - 1) * perPage,
        text: searchText,
      },
    }
    if (!searchText) delete translationsApiConf.params.text

    superAxiosRequest(translationsApiConf)
      .then(({ data }) => {
        setData(data?.result)
        listingStore.fillData(translationsApiConf)
      })
      .catch(() => {})

    superAxiosRequest({
      method: 'get',
      link: 'localization/partitions',
      params: {},
    })
      .then(({ data }) => {
        setPartitions(data)
      })
      .catch(() => {})

    superAxiosRequest({
      method: 'get',
      link: 'localization/subpartitions',
      params: {},
    })
      .then(({ data }) => {
        setSubPartitions(data)
      })
      .catch(() => {})

    superAxiosRequest({
      method: 'get',
      link: 'localization/languages',
      params: {},
    })
      .then(({ data }) => {
        setLanguages(data?.result)
        setLanguagesDictionary(
          data?.result?.reduce((acc, current) => {
            acc[current?.id] = current?.full_name
            return acc
          }, {}),
        )
      })
      .catch(() => {})

    return () => {
      listingStore.dropData()
    }
  }, [page, perPage, searchText])

  const { translate } = useLocalization({
    section: 'user',
    subsection: 'translator',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      search: 'Search',
      search_input: 'Search by student name, surname, or patronymic...',
      date: 'Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      filter: 'Filter',
      changeTranslation: 'Change translation',
      createTranslation: 'Create translation',
      text: 'Text',
      language: 'Language',
      partition: 'Partition',
      subpartition: 'Subpartition',
      page: 'page',
      englishText: 'English Text',
      english: 'English',
      kazakhAndRussian: 'Kazakh / Russian text',
      russian: 'Russian',
      kazakh: 'Kazakh',
      creatingTranslation: 'Creating a new translation',
      createPartition: 'Create Partition',
      of: 'of',
      name: 'Name',
      shortName: 'Short name',
      parentPartition: 'Parent Partition',
      partition_hint:
        'If Parent Partition is not selected, create a Partition, and if selected, create a Subpartition',
    },
  })

  const CreateTranslationModal = () => {
    const ms = {
      modalBodyComponent: () => (
        <CreateTranslation
          partitions={partitions}
          languages={languages}
          subPartitions={subPartitions}
        />
      ),
      button: translate?.save,
      link: 'localization/translations',
      title: translate?.createTranslation,
      type: 'create_translation',
      onBeforeSubmit: onBeforeCreateTranslation,
      onSubmitSuccess: () => {},
      isResponsive: true,
      valid: {
        partition: 'required',
        subPartition: 'required',
        language: 'required',
        translation: 'required',
      },
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }
  const ChangeTranslationModal = () => {
    let link = 'localization/translate'
    const ms = {
      modalBodyComponent: () => (
        <ChangeTranslation
          selectedItem={activeElementState}
          partitions={partitions}
          languages={languages}
          subPartitions={subPartitions}
        />
      ),
      is_put: true,
      link,
      button: translate?.save,
      title: translate?.changeTranslation,
      type: 'change_translation',
      onBeforeSubmit: onBeforeUpdateTranslation,
      isResponsive: true,
      valid: {
        partition: 'required',
        subPartition: 'required',
        language: 'required',
        translation: 'required',
      },
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }
  const CreatePartitionModal = () => {
    const ms = {
      modalBodyComponent: () => (
        <CreatePartition
          selectedItem={activeElementState}
          parentPartitions={partitions}
          languages={languages}
          subPartitions={subPartitions}
        />
      ),
      button: translate?.save,
      link: 'localization/partitions',
      title: translate?.createPartition,
      type: 'create_partition',
      onBeforeSubmit: (data) => {
        return {
          ...data,
          parent_partition: data?.parent_partition?.id || null,
        }
      },
      onSubmitSuccess: (res) => {
        if (res?.parent_partition) {
          setSubPartitions([res, ...subPartitions])
        } else {
          setPartitions([res, ...partitions])
        }
      },
      isResponsive: true,
      valid: {},
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const onRowClickHandler = (
    rowElement,
    e,
    currentLanguage,
    currentPartition,
    currentSubPartition,
  ) => {
    if (e?.currentTarget?.checked) {
      setActiveElement(rowElement?.id)
      superAxiosRequest({
        method: 'get',
        link: 'localization/translations',
        params: {
          section: currentPartition?.short_name,
          subsection: currentSubPartition?.short_name,
        },
      })
        .then(({ data }) => {
          const newSelectedLanguages = data?.result?.reduce((acc, item) => {
            acc[item?.language] = {
              full_language_name: languagesDictionary[item?.language],
              text: item?.text,
            }
            return acc
          }, {})
          newSelectedLanguages['partition'] = currentPartition
          newSelectedLanguages['subPartition'] = currentSubPartition
          newSelectedLanguages['language'] = currentLanguage
          setActiveElementState(newSelectedLanguages)
          setEnglishText(JSON.stringify(newSelectedLanguages[1]?.text))
          setRussianText(JSON.stringify(newSelectedLanguages[2]?.text))
          setKazakhText(JSON.stringify(newSelectedLanguages[3]?.text))
        })
        .catch(() => {})
    } else {
      setActiveElement(null)
      return
    }
  }

  return (
    <div className={st.container}>
      <div className={st.settingUserBox}>
        <div className={st.settingUserBox__head}>
          <PageHeader title={translate?.creatingTranslation}>
            <div className={st.settingUserBox__headBtn}>
              <HeaderButton
                hidePlus={true}
                buttonColor={'red'}
                title={translate?.createPartition || ''}
                onClick={() => CreatePartitionModal()}
              />
              <HeaderButton
                hidePlus={true}
                title={translate?.createTranslation || ''}
                onClick={() => CreateTranslationModal()}
              />
              <HeaderButton
                hidePlus={true}
                buttonColor={'red'}
                title={translate?.changeTranslation || ''}
                onClick={() => ChangeTranslationModal()}
              />
            </div>
          </PageHeader>

          <div className={st.searchFilterValues}>
            <SearchBooks
              onSearch={(text) => {
                setSearchText(text)
                updateFilter({ ...filter, search: text })
                changeTextValue('search', {
                  key: 'search',
                  label: 'Search',
                  value: text,
                })
              }}
              onClear={handleSearchClear}
              translate={translate}
              placeholder={translate?.search}
              value={filter?.search || ''}
              isFilterHidden={true}
            />

            {searchText && <FilterTextValues onDelete={handleSearchClear} />}
          </div>
        </div>
      </div>

      <div className={`${st.containerForTexteria} ${st.bigTextArea}`}>
        <div className={st.textArea}>
          <div className={st.textAreaDiv}>{translate?.english}</div>
          <hr
            style={{
              border: 'none',
              borderTop: '1px solid #DFE6E9',
              width: '100%',
            }}
          />
          <textarea
            disabled={true}
            value={englishText}
            placeholder={translate?.englishText}
          />
        </div>
        <div className={st.textArea}>
          <div className={st.tabs}>
            <p
              className={activeTab === 'kazakh' ? st.activeTab : st.tab}
              onClick={() => handleTabClick('kazakh')}
            >
              {translate?.kazakh}
            </p>
            <p
              className={activeTab === 'russian' ? st.activeTab : st.tab}
              onClick={() => handleTabClick('russian')}
            >
              {translate?.russian}
            </p>
          </div>
          <hr
            style={{
              border: 'none',
              borderTop: '1px solid #DFE6E9',
              width: '100%',
            }}
          />
          <textarea
            disabled={true}
            value={activeTab === 'kazakh' ? kazakhText : russianText}
            placeholder={translate?.kazakhAndRussian}
          />
        </div>
      </div>

      <div className={st.settingUserBox}>
        <div className={style.searchFilterValues}>
          <table className={`${st.table} ${styles.tbodyStriped}`}>
            <thead className={`${st.conversionTbl} ${st.thead}`}>
              <tr>
                <td className={`${st.blackText} ${st.firstColumn}`}>
                  <div className={st.table__checkbox}>{translate?.text}</div>
                </td>
                <td className={`${st.blackText} ${st.otherColumns}`}>
                  {translate?.language}
                </td>
                <td className={`${st.blackText} ${st.otherColumns}`}>
                  {translate?.partition}
                </td>
                <td className={`${st.blackText} ${st.otherColumns}`}>
                  {translate?.subpartition}
                </td>
              </tr>
            </thead>
            <tbody className={st.conversionTbl}>
              {data?.map((item, index) => {
                const currentLanguage = languages?.find(
                  (el) => el.id === item?.language,
                )
                const currentPartition = partitions?.find(
                  (el) => el.id === item?.partition,
                )
                const currentSubPartition = subPartitions?.find(
                  (el) => el.id === item?.subpartition,
                )
                return (
                  <tr key={index}>
                    <td className={`${st.tdTotal} ${st.tdMiddle}`}>
                      <div className={st.table__checkbox}>
                        <input
                          checked={item?.id === activeElement}
                          type='checkbox'
                          onChange={(e) => {
                            onRowClickHandler(
                              item,
                              e,
                              currentLanguage,
                              currentPartition,
                              currentSubPartition,
                            )
                          }}
                        />
                        <span>
                          {JSON.stringify(item?.text).length > 100
                            ? JSON.stringify(item?.text).substring(0, 100) +
                              `...`
                            : JSON.stringify(item?.text)}
                        </span>
                      </div>
                    </td>
                    <td
                      className={`${st.tdTotal} ${st.bdrN} ${st.tdMiddle} ${st.bdlN}`}
                    >
                      {currentLanguage?.full_name || ''}
                    </td>
                    <td
                      className={`${st.tdTotal} ${st.bdrN} ${st.tdMiddle} ${st.bdlN}`}
                    >
                      {currentPartition?.name || ''}
                    </td>
                    <td
                      className={`${st.tdTotal} ${st.bdrN} ${st.tdMiddle} ${st.bdlN}`}
                    >
                      {currentSubPartition?.name || ''}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <div className={st.pagination}>
          <Pagination
            translate={translate}
            limit={+perPage}
            count={listingStore.meta.count_items || 0}
            page={page}
            onChange={setPage}
            onChangePerPage={setPerPage}
          />
        </div>
      </div>
    </div>
  )
}

export default observer(Translate)
